// src/components/Pages/ReportSettingsEditor.js

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getReportSettings, updateReportSettings, createReportSettings } from '../../actions/reportSettingsActions';
import { imgUrl } from '../../actions/types';
import RichTextEditor from 'react-rte';
import { Link } from 'react-router-dom';
// This sub-component does not need changes.
const ReportTypeSettings = ({
  reportType,
  settings,
  title,
  loading,
  onSettingsChange,
  onFileChange,
  onSave,
  onDelete,
  previewImage,
  existingImage,
}) => {
  const currentImage = previewImage || existingImage;
  const editorLogoStyle = {
    display: 'block',
    maxWidth: '200px',
    marginLeft: settings.logoPosition === 'center' || settings.logoPosition === 'right' ? 'auto' : '0',
    marginRight: settings.logoPosition === 'center' || settings.logoPosition === 'left' ? 'auto' : '0',
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header ">
        <h5 className="mb-0">{title} Header & Footer Settings</h5>
      </div>
      <div className="card-body">
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">Header Logo & Alignment</label>
          <div className="col-sm-9">
            {currentImage ? (
              <img src={currentImage} alt="Preview" className="img-thumbnail mb-2" style={editorLogoStyle} />
            ) : (
              <div className="border p-3 text-center text-muted">No Image</div>
            )}
            <div className="d-flex mt-2 align-items-center">
              <div className="custom-file" style={{ maxWidth: '300px' }}>
                <input type="file" className="custom-file-input" id={`customFile_${reportType}`} onChange={(e) => onFileChange(reportType, e)} />
                <label className="custom-file-label" htmlFor={`customFile_${reportType}`}>Choose file</label>
              </div>
              <div className="ml-3">
                <label className="small d-block mb-1">Header Logo Alignment</label>
                <select className="form-control form-control-sm" value={settings.logoPosition || 'left'} onChange={(e) => onSettingsChange(reportType, 'logoPosition', e.target.value)}>
                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">Header Content</label>
          <div className="col-sm-6">
            <RichTextEditor value={settings.headerText || RichTextEditor.createEmptyValue()} onChange={(value) => onSettingsChange(reportType, 'headerText', value)} />
          </div>
          <div className="col-sm-3">
            <label>Header Text Alignment</label>
            <select className="form-control" value={settings.headerAlign || ''} onChange={(e) => onSettingsChange(reportType, 'headerAlign', e.target.value)}>
              <option value="">Select</option>
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">Footer Content</label>
          <div className="col-sm-6">
            <RichTextEditor value={settings.footerText || RichTextEditor.createEmptyValue()} onChange={(value) => onSettingsChange(reportType, 'footerText', value)} />
          </div>
          <div className="col-sm-3">
            <label>Footer Text Alignment</label>
            <select className="form-control" value={settings.footerAlign || ''} onChange={(e) => onSettingsChange(reportType, 'footerAlign', e.target.value)}>
              <option value="">Select</option>
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
        </div>
      </div>
      <div className="card-footer text-right bg-light">
        <button type="submit"className="btn btn-success rounded-pill" onClick={() => onSave(reportType)} disabled={loading}>
          {loading ? 'Saving...' : (settings.id ? 'Update ' : 'Save ') + title + " report"}
        </button>
        {/* <button className="btn btn-outline-danger ml-2" onClick={() => onDelete(reportType)} disabled={!settings.id}>
          Delete
        </button> */}
      </div>
    </div>
  );
};

ReportTypeSettings.propTypes = {
  reportType: PropTypes.string.isRequired,
  settings: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onSettingsChange: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  previewImage: PropTypes.string,
  existingImage: PropTypes.string,
};

class ReportSettingsEditor extends Component {
  constructor(props) {
    super(props);
    // 🪵 [LOG] Initial component state setup
    console.log('[LOG] Constructor: Initializing component state.');
    this.state = {
      activeTab: 'prescription',
      localSettings: {
        prescription: this.createInitialSettings(),
        medicalRecord: this.createInitialSettings(),
        invoice: this.createInitialSettings(),
      },
      filesToUpload: {},
      previews: {},
    };
  }

  createInitialSettings = () => ({
    id: null,
    headerImage: null,
    headerText: RichTextEditor.createEmptyValue(),
    footerText: RichTextEditor.createEmptyValue(),
    logoPosition: 'left',
    headerAlign: 'left',
    footerAlign: 'center',
  });

  componentDidMount() {
    const doctorID = localStorage.getItem('hospitalCode');
    if (doctorID) {
      // 🪵 [LOG] Fetching initial data
      console.log(`[LOG] ComponentDidMount: Fetching settings for doctor ID: ${doctorID}`);
      this.props.getReportSettings(doctorID);
    }
  }

  // --- (FINAL CORRECTED VERSION) ---
  // This method now correctly synchronizes Redux props to local state.
  componentDidUpdate(prevProps) {
    // 🪵 [LOG] Tracking component updates
    console.log('[LOG] ComponentDidUpdate: Checking for props changes.');
    
    // Only update state if the settings data from Redux has actually changed
    if (this.props.settings !== prevProps.settings && this.props.settings) {
      // 🪵 [LOG] Detected changes in Redux props
      console.log('[LOG] ... Redux props have changed. Synchronizing local state with:', this.props.settings);

      const serverSettings = this.props.settings;
      const updatedLocalSettings = { ...this.state.localSettings };

      // Loop through the report types ('prescription', 'medicalRecord', etc.)
      Object.keys(updatedLocalSettings).forEach(reportKey => {
        const settingFromServer = serverSettings[reportKey];

        if (settingFromServer) {
          // ✅ If data exists on the server, create a clean state object by explicitly mapping each field.
          // This prevents issues with mismatched property names (e.g., API 'HeaderLogo' vs state 'headerImage').
          updatedLocalSettings[reportKey] = {
            id: settingFromServer.id, // The most important field!
            headerImage: settingFromServer.HeaderLogo,
            logoPosition: settingFromServer.HeaderLogoAlign,
            headerText: RichTextEditor.createValueFromString(settingFromServer.HeaderText || '', 'html'),
            headerAlign: settingFromServer.HeaderTextAlign,
            footerText: RichTextEditor.createValueFromString(settingFromServer.FooterText || '', 'html'),
            footerAlign: settingFromServer.FooterTextAlign,
          };
          // 🪵 [LOG] Mapped data
          console.log(`[LOG] ... Mapped server data for [${reportKey}] to local state:`, updatedLocalSettings[reportKey]);

        } else {
          // If no server data exists for this report type, ensure it's reset to its initial empty state.
          updatedLocalSettings[reportKey] = this.createInitialSettings();
          // 🪵 [LOG] No server data found
          console.log(`[LOG] ... No server data found for [${reportKey}]. Resetting to initial state.`);
        }
      });

      // Update the component's state once with the fully synchronized data.
      this.setState({ localSettings: updatedLocalSettings });
    }
  }

  handleSettingsChange = (reportType, field, value) => {
    this.setState((prevState) => ({
      localSettings: {
        ...prevState.localSettings,
        [reportType]: {
          ...prevState.localSettings[reportType],
          [field]: value,
        },
      },
    }));
  };

  handleFileChange = (reportType, e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prevState) => ({
        filesToUpload: {
          ...prevState.filesToUpload,
          [`${reportType}HeaderImage`]: file,
        },
        previews: {
          ...prevState.previews,
          [reportType]: URL.createObjectURL(file),
        },
      }));
    }
  };

  handleSave = (reportType) => {
    // 🪵 [LOG] Save process initiated
    console.log(`[LOG] handleSave: Initiated for reportType: ${reportType}`);
    const doctorID = localStorage.getItem('hospitalCode');
    const settingsForReport = this.state.localSettings[reportType];
    const fileToUpload = this.state.filesToUpload[`${reportType}HeaderImage`];
    const formData = new FormData();
     const cleanHtml = (html) => {
        return html.replace(/&nbsp;/g, ' ').trim();
    };
    formData.append('hospitalID', doctorID);
    formData.append('ReportType', reportType);
    if (fileToUpload) {
      formData.append('HeaderLogo', fileToUpload);
    }
    formData.append('HeaderLogoAlign', settingsForReport.logoPosition || 'left');
    // formData.append('HeaderText', settingsForReport.headerText.toString('html'));
    // formData.append('HeaderTextAlign', settingsForReport.headerAlign || 'left');
    // formData.append('FooterText', settingsForReport.footerText.toString('html'));
    // formData.append('FooterTextAlign', settingsForReport.footerAlign || 'center');
     formData.append('HeaderText', cleanHtml(settingsForReport.headerText.toString('html')));
    formData.append('FooterText', cleanHtml(settingsForReport.footerText.toString('html')));
    
    formData.append('HeaderTextAlign', settingsForReport.headerAlign || 'left');
    formData.append('FooterTextAlign', settingsForReport.footerAlign || 'center');

    // ✅ This logic is now reliable because componentDidUpdate correctly sets the ID.
    if (settingsForReport.id) {
      // 🪵 [LOG] Dispatching UPDATE action
      console.log(`[LOG] ... Found ID: ${settingsForReport.id}. Dispatching UPDATE action.`);
      formData.append('id', settingsForReport.id);
      this.props.updateReportSettings(formData);
    } else {
      // 🪵 [LOG] Dispatching CREATE action
      console.log('[LOG] ... No ID found. Dispatching CREATE action.');
      this.props.createReportSettings(formData);
    }
  };

  handleDelete = (reportType) => {
    const settings = this.state.localSettings[reportType];
    if (settings.id && window.confirm(`Are you sure you want to delete the settings for ${reportType}?`)) {
      // You would need to create and connect a `deleteReportSettings` action here.
      console.log(`[LOG] Deleting settings for ID: ${settings.id}`);
      // this.props.deleteReportSettings(settings.id);
    }
  };

  render() {
    const { loading } = this.props;
    const { localSettings, previews, activeTab } = this.state;
    const reportTitles = {
      prescription: 'Prescription',
      medicalRecord: 'Medical Record',
      invoice: 'Invoice',
    };
    const activeSettings = localSettings[activeTab];

    // 🪵 [LOG] Render method called
    console.log(`[LOG] render: Rendering component. Active Tab: ${activeTab}`);

    return (
      <div className="">
         <div className="page-header filter-bar rounded ">
            <div className="row align-items-center">
                <div className="col">
                    <h4 className="page-title" >Report Settings</h4>
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/doctor/dashboard">Doctor Dashboard</Link></li>
                        <li className="breadcrumb-item active">Report Header & Footer</li>
                    </ul>
                </div>
            </div>
        </div>
        <ul className="nav nav-tabs mb-3">
          {Object.keys(reportTitles).map((key) => (
            <li className="nav-item" key={key}>
              <a className={`nav-link ${activeTab === key ? 'active' : ''}`} style={{ cursor: 'pointer' }}
                onClick={(e) => { e.preventDefault(); this.setState({ activeTab: key }); }}
                href={`#${key}`}
              >{reportTitles[key]}</a>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {activeSettings && (
            <ReportTypeSettings
              key={activeTab}
              reportType={activeTab}
              title={reportTitles[activeTab]}
              settings={activeSettings}
              loading={loading}
              onSettingsChange={this.handleSettingsChange}
              onFileChange={this.handleFileChange}
              onSave={this.handleSave}
              onDelete={this.handleDelete}
              previewImage={previews[activeTab]}
              // ✅ This logic now works because `headerImage` is correctly mapped in state
              existingImage={activeSettings.headerImage ? `${imgUrl}${activeSettings.headerImage}` : null}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.reportSettings.settings,
  loading: state.reportSettings.loading,
  error: state.reportSettings.error,
});

export default connect(mapStateToProps, { getReportSettings, updateReportSettings, createReportSettings })(ReportSettingsEditor);